import React, { useEffect } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import moment from 'moment';
import { debounce, escape } from 'lodash';
import { createSelector } from "reselect";
import { useSelector, useDispatch } from "react-redux";
import { getUserProfile } from "store/account/actions";
import { getConfig } from "store/config/actions";
import { loginSuccess, logoutUser } from "store/actions";

const Authmiddleware = (props) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const CombinedProperties = createSelector(
    (state) => state.Login,
    (login) => ({
      isAuthenticated: login.isAuthenticated,
      token: login.sessionToken,
      expiredTime: login.expiredTime,
    })
  );

  const { isAuthenticated, token, expiredTime } = useSelector(CombinedProperties);

  let isRefresh = false;

  const debounceRefresh = debounce(async () => {
    const expiredTime = localStorage.getItem('expiredTime');
    if (
      localStorage.getItem('sessionToken') && expiredTime &&
      !isRefresh &&
      moment().diff(moment(expiredTime), 'minute') < 0
    ) {
      try {
        isRefresh = true;
        // POST /api/auth/refresh?refreshToken=<token> → ApiResponse<LoginResponse>
        const res = await fetch(
          `${process.env.REACT_APP_SERVER_URL}api/auth/refresh?refreshToken=${encodeURIComponent(
            localStorage.getItem('refreshToken'),
          )}`,
          {
            method: 'post',
            headers: { 'Content-Type': 'application/json' },
          },
        );
        const body = await res.json();
        const newToken = body?.data ?? body; // unwrap { success, data } envelope

        localStorage.setItem('sessionToken', newToken.accessToken);
        localStorage.setItem('refreshToken', newToken.refreshToken);
        localStorage.setItem(
          'expiredTime',
          moment().add(newToken.expiresIn, 'millisecond'),
        );
        dispatch(loginSuccess(newToken));
        isRefresh = false;
      } catch (error) {
        isRefresh = false;
      }
    }
    if (
      moment().diff(moment(localStorage.getItem('expiredTime')), 'minute') > 0
    ) {
      localStorage.removeItem('sessionToken');
      localStorage.removeItem('fullName');
      localStorage.removeItem('id');
      localStorage.removeItem('refreshToken');
      localStorage.removeItem('expiredTime');
      window.location.href = '/login';
    }
  }, 200);

  useEffect(() => {
    if (token && expiredTime) {
      const t = moment(expiredTime).diff(moment(), 'minute');
      if (t > 5) {
        dispatch(getUserProfile(navigate));
        dispatch(getConfig(navigate));
      } else if (t >= 0) {
        debounceRefresh()
      } else {
        dispatch(logoutUser(navigate));
      }
    } else {
      const expiredTime = localStorage.getItem('expiredTime');
      const t = moment(expiredTime).diff(moment(), 'minute');
      if (t > 0) {
        debounceRefresh()
      } else {
        dispatch(logoutUser(navigate));
      }
    }
  }, [token, expiredTime]);

  return (<React.Fragment>
    {props.children}
  </React.Fragment>);
};

export default Authmiddleware;
